import React from 'react'
import { PointCardProps } from './types'
import styles from './Point.module.css'

export default function PointCard({
    image,
    textImage,
    title,
    description,
    subImage,
    textImageAlt,
    subImageAlt,
    imageAlt,
}: PointCardProps) {
    return (
        <li>
            <figure>
                <img src={image} alt={imageAlt ?? ''} />
            </figure>
            <div className={styles.pointTextBox}>
                <h2>
                    <img src={textImage} alt={textImageAlt ?? ''} />
                </h2>
                <h3>{title}</h3>
                <p>{description}</p>
                {subImage && (
                    <img
                        className={styles.pointSubImage}
                        src={subImage}
                        alt={subImageAlt ?? ''}
                    />
                )}
            </div>
        </li>
    )
}
